// extracted by mini-css-extract-plugin
export default {"values":"Values_values__z3ndZ","icon":"Values_icon__jeTok","valueText":"Values_valueText__LKyGF","heading":"Values_heading__1KoEr","content":"Values_content__psNjY"};